module.exports = __webpack_public_path__ + "static/media/portfolio1 (49).080cdb7b.jpeg";